<template>

  <div class="containerDD">
	<div v-if="!isOpen" style="display:flex;position:relative;" :class="'tab current '+radio"  @click="openTab">
	<div  >{{radio}}</div>

	<div class="downArrow" style="position:absolute;right:3em;"></div>
	
	</div>
	<div class="tabsDD" v-show="isOpen">
    
		<input type="radio" id="radio-1" name="tabs" value="Advanced" v-model="radio" checked/>
		<label class="tab" for="radio-1" @click="closeTab('Advanced')">Advanced</label>
    	<input type="radio" id="radio-2" name="tabs" value="Intermediate" v-model="radio" />
		<label class="tab" for="radio-2" @click="closeTab('Intermediate')">Intermediate</label>
		<input type="radio" id="radio-3" name="tabs" value="Beginner" v-model="radio" />
		<label class="tab" for="radio-3" @click="closeTab('Beginner')">Beginner</label>
    	<input type="radio" id="radio-4" name="tabs" value="Novice" v-model="radio" />
		<label class="tab" for="radio-4" @click="closeTab('Novice')">Novice</label>
    	<input type="radio" id="radio-5" name="tabs" value="Relaxed" v-model="radio" />
		<label class="tab" for="radio-5" @click="closeTab('Relaxed')">Relaxed</label>
    
		<span class="glider"></span>
   
	</div>
</div>
</template>

<script>
import ValidIcon from '@/components/ValidIcon.vue';
import Validate from '@/mixins/validate.js'

export default {
    name: "textInput",
    mixins:[Validate],
    components:{ValidIcon},
    props: {
        items: {
            type: Array,
            required: false,
            default: () => [],
        },
      

    },
    data() {
        return {
            radio:"Advanced",
            isOpen:false,
           
        };
    },
    mounted() {
       
    },
    destroyed() {
        
    },
    computed:{
      
    },
    methods: {
		setValue(val){
		this.radio=val
	  },
		isChecked(val){
			return this.radio==val
		},
      openTab(){
		this.isOpen=true;
		//this.radio=null
	  },
	  closeTab(val){
		this.isOpen=false;
		this.radio=val;
		//this.radio=null
	  }
       
    },
    watch:{
     radio(val){
		if(val){
			 this.$emit("selected",val)
	  		this.isOpen=false;
		}
     
     }
    }
   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/css/colors.scss";

.containerDD {
	
	
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
  	text-transform: none;
	width:100%;
}
.tabsDD {
	display:flex;
	flex-direction: column;
	position: relative;
	width:100%;
	border-radius: 99px; 
	* {
		z-index: 2;
	}
}

input[type="radio"] {
	display: none;
}

.tab {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 3em;
	width: 100%;
	font-size: 1em;
	font-weight: 500;
	border-radius: 99px; 
	cursor: pointer;
	transition: color 0.15s ease-in;
}
.current{
	color:#000;
	font-weight: 700;;
}


input[type="radio"] {
	&:checked {
		& + label {
			color: #000;
      		font-weight:700;
			
		}
	}
}

input[id="radio-1"] {
	&:checked {
		& ~ .glider {
			transform: translateY(0%);
      		background-color: $advanced-color
		}
	}
}

input[id="radio-2"] {
	&:checked {
		 & ~ .glider {
			transform: translateY(100%);
      		background-color: $intermediate-color
		}
	}
}

input[id="radio-3"] {
	&:checked {
		& ~  .glider {
			transform: translateY(200%);
      background-color: $beginner-color;
		}
	}
}
  input[id="radio-4"] {
	&:checked {
		& ~  .glider {
			transform: translateY(300%);
      		background-color: $novice-color;
		}
	}
}
input[id="radio-5"] {
	&:checked {
		& ~  .glider {
			transform: translateY(400%);
      		background-color: $relaxed-color;
		}
	}
}

.glider {
	position: absolute;
	display: flex;
	height: 3em;
	width: 100%;
	background-color: var(--secondary-color);
	z-index: 1;
	border-radius: 99px; 
	transition: 0.25s ease-out;
}
.downArrow{
  width: 0; 
  height: 0; 
  border-left: .7em solid transparent;
  border-right: .7em solid transparent;
  border-top: 1em solid #000;	
}
</style>
